__turbopack_context__.v({
  "main": "page-module___8aEwW__main",
  "pageTitle": "page-module___8aEwW__pageTitle",
  "pageWrapper": "page-module___8aEwW__pageWrapper",
  "section": "page-module___8aEwW__section",
  "sectionTitle": "page-module___8aEwW__sectionTitle",
});
